import {Bootstrap} from "./Bootstrap";

export class Video {
	
	static isSmartPhone = false;
	static isHls = false;
	
	static init() {
		if(Hls.isSupported()) { //HLS対応
			this.isHls = true;
		}
		if(Bootstrap.isSmartPhone()){
			this.isSmartPhone = true;
		}
		Video.initLoop();
		Video.initConcept();
	}
	
	static initLoop(){
		document.querySelectorAll('[data-role="loopVideo"]').forEach((video)=>{
			let src;
			if(this.isHls){
				const hls = new Hls();
				src = (this.isSmartPhone)? video.dataset.srcSpHls:video.dataset.srcPcHls;
				hls.loadSource(src);
				hls.attachMedia(video);
			}else{
				src = (this.isSmartPhone)? video.dataset.srcSp:video.dataset.srcPc;
				video.src = src;
			}
			video.play();			
		});
	}
	static initConcept() {
		
		document.querySelectorAll('[data-role="conceptVideo"]').forEach((wrap) => {
			const video = wrap.querySelector('[data-role="conceptVideoVideo"]');
			let src;
			if(this.isHls){
				const hls = new Hls();
				hls.loadSource(video.dataset.srcHls);
				hls.attachMedia(video);
			}else {
				video.src = video.dataset.src;
			}
			
			const btn = wrap.querySelector('[data-role="conceptVideoBtn"]');
			btn.addEventListener('click',(e)=>{
				wrap.classList.add('is-plaid');
				if(wrap.classList.contains('is-play')){
					wrap.classList.remove('is-play');
					video.pause();
				}else{
					wrap.classList.add('is-play');
					video.play();
				}
			});
		});
	}
}